'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const BezierCurveIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M3.25534 6.99994L9.36524 6.95104M20.748 6.99994L14.6207 6.95104M9.36524 7.15104C6.26524 8.25104 5.24799 9.99994 5.04799 13.3999M18.954 13.3644C18.754 9.96443 17.7207 8.15104 14.6207 7.15104M9.76888 4.75104H14.2689V9.25104H9.76888V4.75104ZM16.754 13.7644H21.254V18.2644H16.754V13.7644ZM2.75 13.7644H7.25V18.2644H2.75V13.7644ZM5.15534 6.99994C5.15534 7.69994 4.55534 8.19994 3.95534 8.19994C3.35534 8.19994 2.75534 7.69994 2.75534 6.99994C2.75534 6.29994 3.25534 5.79994 3.95534 5.79994C4.65534 5.79994 5.15534 6.29994 5.15534 6.99994ZM21.248 6.99994C21.248 7.69994 20.648 8.19994 20.048 8.19994C19.448 8.19994 18.848 7.69994 18.848 6.99994C18.848 6.29994 19.448 5.79994 20.048 5.79994C20.648 5.79994 21.248 6.29994 21.248 6.99994Z",
        stroke: "currentColor",
        strokeLinecap: "square"
      }
    )
  }
);
const VpBezierCurveIcon = forwardRef(BezierCurveIcon);

export { VpBezierCurveIcon as default };
